












import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ReportDetails } from '@/models/reports/report-details';

@Component
export default class DeleteReportModal extends Vue {
    @Prop({ required: true, type: Boolean }) public show: boolean;
    @Prop({ required: true }) public report: ReportDetails;
    public showing: boolean = this.show;

    private hide() {
        this.$emit('cancel-report-delete');
    }
}
